module.exports = __webpack_public_path__ + "static/media/work-img2.1a0f2e74.jpg";